"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROITextInput = void 0;
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ROITextInput = (function (_super) {
    __extends(ROITextInput, _super);
    function ROITextInput() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.originalValue = null;
        _this.handleBlur = function () {
            var _a, _b;
            _this.handleEdit();
            (_b = (_a = _this.props).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        _this.handleEdit = function () {
            var _a;
            if (_this.props.onValueEdited && !(0, lodash_1.isNil)(_this.originalValue) && _this.originalValue !== _this.props.value) {
                var value = (_a = _this.props.value) !== null && _a !== void 0 ? _a : "";
                _this.props.onValueEdited(_this.props.inputName, value);
            }
            _this.originalValue = null;
        };
        return _this;
    }
    ROITextInput.prototype.componentWillUnmount = function () {
        this.handleEdit();
    };
    ROITextInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, inputName = _a.inputName, value = _a.value, onChange = _a.onChange, onValueEdited = _a.onValueEdited, rest = __rest(_a, ["inputName", "value", "onChange", "onValueEdited"]);
        return (react_1.default.createElement(kaleidoscope_1.TextInput, __assign({}, rest, { value: value, onChange: function (newValue) { return onChange(inputName, newValue); }, onFocus: function () { return (0, mobx_1.runInAction)(function () { return (_this.originalValue = value !== null && value !== void 0 ? value : ""); }); }, onBlur: this.handleBlur })));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ROITextInput.prototype, "originalValue", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROITextInput.prototype, "handleEdit", void 0);
    ROITextInput = __decorate([
        mobx_react_1.observer
    ], ROITextInput);
    return ROITextInput;
}(react_1.default.Component));
exports.ROITextInput = ROITextInput;
